import {authTokenProvider} from "../AuthTokenProvider";
import {getTokenOptions} from "../config/getAccountSettingsToken";

const X_API_KEY = process.env.REACT_APP_X_API_KEY;

function addXApiKeyHeader(headers = {}) {
    headers["X-API-KEY"] = X_API_KEY;
    return headers;
}

async function attachAuth(headers, scope, forceRefresh = false) {
    try {
        const tokenOptions = getTokenOptions(scope) || {};
        const token = await authTokenProvider.getToken(
            forceRefresh ? {...tokenOptions, cacheMode: "off"} : tokenOptions
        );
        if (token) {
            headers["Authorization"] = `Bearer ${token}`;
        }
    } catch (e) {
        console.error("Token fetch failed", e);
    }
}

async function request(url, options = {}, scope, privateRoute= true) {
    let headers = options.headers || {};

    addXApiKeyHeader(headers);
    if(privateRoute) {
        await attachAuth(headers, scope);
    }
    const finalOptions = {
        ...options,
        headers
    };
    let response = await fetch(url, finalOptions);

    // A cached token the API no longer accepts: get a fresh one and retry once before surfacing the 401.
    if (response.status === 401 && privateRoute) {
        await attachAuth(headers, scope, true);
        response = await fetch(url, finalOptions);
    }
    return handleResponse(response);
}

export const fetchWrapper = {
    get: (url, scope, privateRoute=true) =>
        request(url, { method: "GET" }, scope, privateRoute),

    post: (url, body, scope) =>
        request(
            url,
            {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            },
            scope
        ),

    put: (url, body, scope) =>
        request(
            url,
            {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body)
            },
            scope
        ),

    delete: (url, scope) =>
        request(
            url,
            { method: "DELETE", headers: { accept: "application/json" } },
            scope
        ),
};

export async function handleResponse(response) {
    try {
        return response.text().then((text) => {
            try {
                if (response.ok) {
                    if (text) {
                        return text && JSON.parse(text);
                    }
                    return { message: 'ok' };
                } else if (response.status === 422) {
                    const data = text && JSON.parse(text);
                    return { error: data?.msg || data?.message || `Unprocessable request (${response.status})` };
                } else if (response.status === 400) {
                    const data = text && JSON.parse(text);
                    return { error: data?.error || data?.message || `Bad request (${response.status})` };
                } else if (response.status === 409) {
                    const data = text && JSON.parse(text);
                    return { error: data?.message || data?.msg || 'Conflict error' };
                } else if (response.status === 401) {
                    const data = text && JSON.parse(text);
                    return { error: data?.error || data?.message || `Unauthorized (${response.status})` };
                } else if (!response.ok) {
                    const data = text && JSON.parse(text);
                    const error = (data && (data.message || data.error)) || response.statusText || `Request failed (${response.status})`;
                    console.log(error);
                    return { error };
                }
            } catch (e) {
                return { error: e.message || 'Unknown error' };
            }
        });
    } catch (e) {
        return { error: e.message || 'Unknown error' };
    }
}

